import { uploadFileToS3, BUCKET_NAME } from "./uploadFileToS3";

const generateKey = (fileName) => {
  const cleanName = fileName.replace(/[^a-zA-Z0-9._-]/g, "_");
  const parts = cleanName.split(".");

  if (parts.length > 1) {
    const ext = parts.pop();
    const name = parts.join(".");
    return `${name}-${Date.now()}.${ext}`;
  }

  return `${cleanName}-${Date.now()}`;
};

const resolveUpload = async (file, keyPrefix) => {
  if (!file) return null;

  if (typeof file === "string") return file;
  if (file?.isExisting && file?.url) return file.url;
  if (!(file instanceof File) && !(file instanceof Blob) && file?.url) {
    return file.url;
  }

  const key = generateKey(file.name);
  const res = await uploadFileToS3(BUCKET_NAME, file, key);
  return res.s3Url;
};

export const uploadAllPreOnboardingFiles = async (
  uploadedFiles,
  driverMobile,
  previouslyUploaded = {},
) => {
  const uploadedDocs = {};
  const failures = [];

  for (const [docId, fileObj] of Object.entries(uploadedFiles)) {
    const cached = previouslyUploaded[docId] || {};
    uploadedDocs[docId] = { ...cached };

    try {
      if (fileObj.single && !cached.url) {
        uploadedDocs[docId].url = await resolveUpload(fileObj.single);
      }

      if (fileObj.front && !cached.frontUrl) {
        uploadedDocs[docId].frontUrl = await resolveUpload(fileObj.front);
      }

      if (fileObj.back && !cached.backUrl) {
        uploadedDocs[docId].backUrl = await resolveUpload(fileObj.back);
      }

      if (fileObj.multiple) {
        const existingUrls = cached.urls || [];
        const alreadyDone = existingUrls.length;
        uploadedDocs[docId].urls = [...existingUrls];

        for (
          let index = alreadyDone;
          index < fileObj.multiple.length;
          index++
        ) {
          const file = fileObj.multiple[index];
          uploadedDocs[docId].urls.push(await resolveUpload(file));
        }
      }
    } catch (error) {
      console.error(`Failed to upload document ${docId}:`, error);
      failures.push(docId);
    }
  }

  if (failures.length > 0) {
    const err = new Error(`Failed to upload: ${failures.join(", ")}`);
    err.partialResults = uploadedDocs;
    err.failedDocIds = failures;
    throw err;
  }

  return uploadedDocs;
};
